const PRODUCT_FAQ_SELECTOR = '[data-component="product-faq"]';
const PRODUCT_FAQ_ITEM_SELECTOR = '[data-product-faq-item]';
const PRODUCT_FAQ_TRIGGER_SELECTOR = '[data-product-faq-trigger]';
const PRODUCT_FAQ_PANEL_SELECTOR = '[data-product-faq-panel]';
const PRODUCT_FAQ_NAV_KEYS = new Set(['ArrowDown', 'ArrowUp', 'Home', 'End']);
const PRODUCT_FAQ_MOBILE_QUERY = '(max-width: 1023px)';

const getProductFaqState = (component) => ({
    items: Array.from(component.querySelectorAll(PRODUCT_FAQ_ITEM_SELECTOR)),
    triggers: Array.from(component.querySelectorAll(PRODUCT_FAQ_TRIGGER_SELECTOR)),
    panels: Array.from(component.querySelectorAll(PRODUCT_FAQ_PANEL_SELECTOR)),
});

const setProductFaqItemState = (state, index, expanded) => {
    const item = state.items[index];
    const trigger = state.triggers[index];
    const panel = state.panels[index];

    if (!item || !trigger || !panel) {
        return;
    }

    item.classList.toggle('is-open', expanded);
    trigger.setAttribute('aria-expanded', String(expanded));
    panel.setAttribute('aria-hidden', String(!expanded));
    panel.toggleAttribute('inert', !expanded);
};

const closeProductFaqItems = (state) => {
    state.items.forEach((_, index) => {
        setProductFaqItemState(state, index, false);
    });
};

const applyProductFaqResponsiveDefault = (state, mobileQuery) => {
    closeProductFaqItems(state);

    if (!mobileQuery.matches) {
        return;
    }

    const defaultOpenIndex = state.items.findIndex((item) =>
        item.hasAttribute('data-product-faq-mobile-default-open'),
    );

    if (defaultOpenIndex >= 0) {
        setProductFaqItemState(state, defaultOpenIndex, true);
    }
};

const getProductFaqFocusIndex = (key, currentIndex, lastIndex) => {
    switch (key) {
        case 'ArrowDown':
            return currentIndex === lastIndex ? 0 : currentIndex + 1;
        case 'ArrowUp':
            return currentIndex === 0 ? lastIndex : currentIndex - 1;
        case 'Home':
            return 0;
        case 'End':
            return lastIndex;
        default:
            return currentIndex;
    }
};

const bindProductFaq = (component) => {
    const state = getProductFaqState(component);

    if (!state.triggers.length || state.triggers.length !== state.panels.length) {
        return;
    }

    const mobileQuery = window.matchMedia(PRODUCT_FAQ_MOBILE_QUERY);
    applyProductFaqResponsiveDefault(state, mobileQuery);

    state.triggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
            const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';

            closeProductFaqItems(state);
            if (shouldOpen) {
                setProductFaqItemState(state, index, true);
            }
        });

        trigger.addEventListener('keydown', (event) => {
            if (!PRODUCT_FAQ_NAV_KEYS.has(event.key)) {
                return;
            }

            event.preventDefault();
            const nextIndex = getProductFaqFocusIndex(
                event.key,
                index,
                state.triggers.length - 1,
            );
            state.triggers[nextIndex].focus();
        });
    });

    if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', () => {
            applyProductFaqResponsiveDefault(state, mobileQuery);
        });
    }
};

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(PRODUCT_FAQ_SELECTOR).forEach(bindProductFaq);
});
